window.addEventListener('DOMContentLoaded', () => {
  const $homeKV = document.querySelector('#homeKV');
  if ($homeKV) {
    const VIDEO_TITLES = ['VISION 2030 OASIS', 'SF-23', 'MOBILE STUDIO'];
    const $video = $homeKV.querySelector('video');
    $video.addEventListener('timeupdate', (e) => {
      const currentTime = $video.currentTime;
      if (currentTime > 0 && currentTime < 10.5) {
        document.querySelector('#homeKV h1 span').innerText = VIDEO_TITLES[0];
      } else if (currentTime >= 11 && currentTime < 22.5) {
        document.querySelector('#homeKV h1 span').innerText = VIDEO_TITLES[1];
      } else {
        document.querySelector('#homeKV h1 span').innerText = VIDEO_TITLES[2];
      }
    });
    window.addEventListener('INTRO_END', () => {
      $video.currentTime = 0;
      $video.play();
    })

  };

  const $homeFeatures = document.querySelector('#homeFeatures');
  if ($homeFeatures) {
    const $homeOasisCanvas = document.querySelector('#homeOasisCanvas');
    const path = $homeOasisCanvas.getAttribute('data-path');
    const frames = parseInt($homeOasisCanvas.getAttribute('data-frames'));
    const ctx = $homeOasisCanvas.getContext('2d');
    const canvasWidth = $homeOasisCanvas.width;
    const canvasHeight = $homeOasisCanvas.height;
    let currentFrame = index => (
      `${path}${String(index).padStart(3, '0')}.webp`
    );

    const images = [];
    const oasis = {
      frame: 0
    };

    function loadImagesWithLimit(frames, currentFrame, limit = 4) {
      const images = [];
      let index = 0;
      let active = 0;

      return new Promise((resolve, reject) => {
        function next() {
          if (index >= frames && active === 0) {
            resolve(images);
            return;
          }
          while (active < limit && index < frames) {
            const i = index++;
            active++;
            const img = new Image();
            img.src = currentFrame(i);
            img.onload = () => {
              images[i] = img;
              if ( i === 0 ) render(img); // Render the first image immediately
              active--;
              next();
            };
            img.onerror = reject;
          }
        }
        next();
      });
    }

// Usage
    loadImagesWithLimit(frames, currentFrame, 30).then(loadedImages => {
      images.push(...loadedImages);
      render();
    });

    gsap.to(oasis, {
      frame: frames - 1,
      snap: 'frame',
      ease: 'none',
      scrollTrigger: {
        trigger: $homeFeatures,
        start: 'top top',
        end: 'bottom top',
        scrub: 1,
        // markers: true,
      },
      onUpdate: render
    });


    function render(renderImg = null) {
      const img = renderImg ? renderImg :  images[ oasis.frame];
      if (!img) return;
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      ctx.drawImage(img, 0, 0);
    }

    const slider = new Swiper('#homeFeatures .features .swiper', {
      loop: true,
      parallax: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      }
    })
  }
})